import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { Sidebar } from '@/components/Sidebar';
import { EmailVerificationBanner } from '@/components/EmailVerificationBanner';

// Authenticated dashboard chrome. Auth gating remains client-side via the
// zustand auth store — same enforcement contract as the previous Next layout.
export default function DashboardLayout() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) return null;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 ml-64">
        <EmailVerificationBanner />
        <Outlet />
      </main>
    </div>
  );
}
